namespace $.$$ {

	export class $shm_agent_message_text extends $.$shm_agent_message_text {

		link_click( next?: MouseEvent ) {
			if( next === undefined ) return null
			if( next.button || next.ctrlKey || next.metaKey || next.shiftKey || next.altKey ) return next
			const target = next.target as Element | null
			const link = target?.closest?.( 'a' )
			const uri = link?.getAttribute( 'href' ) ?? ''
			if( !/^file:/i.test( uri ) ) return next
			next.preventDefault()
			this.file_open( uri, next )
			return next
		}

		internal_context_tag( tag: string, attributes: string ) {
			return tag === 'codex_internal_context'
				|| tag === 'environment_context'
				|| tag === 'recommended_plugins'
				|| tag === 'multi_agent_mode'
				|| tag === 'hitalama-goal-control'
				|| tag === 'system-reminder'
				|| tag === 'local-command-caveat'
				|| tag === 'turn_aborted'
				|| tag === 'instructions'
				|| tag.endsWith( '_context' )
				|| tag.endsWith( '_instructions' )
				|| tag.endsWith( '-context' )
				|| tag.endsWith( '-instructions' )
				|| tag === 'permissions' && /\binstructions\b/i.test( attributes )
		}

		internal_context_title( tag: string, attributes: string ) {
			if( tag === 'codex_internal_context' ) {
				const source_match = /\bsource\s*=\s*(?:"([^"]*)"|'([^']*)')/i.exec( attributes )
				const source = ( source_match?.[ 1 ] ?? source_match?.[ 2 ] ?? '' ).trim()
				return source ? `Внутренний контекст · ${ source }` : 'Внутренний контекст'
			}

			const titles: Record< string, string > = {
				environment_context: 'Контекст окружения',
				recommended_plugins: 'Рекомендуемые плагины',
				multi_agent_mode: 'Режим нескольких агентов',
				'hitalama-goal-control': 'Управление целью Hitalama',
				'system-reminder': 'Системное напоминание',
				'local-command-caveat': 'Контекст локальной команды',
				turn_aborted: 'Прерванный запрос',
				instructions: 'Инструкции',
				permissions: 'Инструкции · permissions',
			}
			if( titles[ tag ] ) return titles[ tag ]
			if( tag.endsWith( '_instructions' ) ) return `Инструкции · ${ tag.slice( 0, -'_instructions'.length ) }`
			if( tag.endsWith( '-instructions' ) ) return `Инструкции · ${ tag.slice( 0, -'-instructions'.length ) }`
			if( tag.endsWith( '_context' ) ) return `Контекст · ${ tag.slice( 0, -'_context'.length ) }`
			if( tag.endsWith( '-context' ) ) return `Контекст · ${ tag.slice( 0, -'-context'.length ) }`
			return tag
		}

		internal_context_text() {
			const source = this.text()
			const fences = [ ... source.matchAll( /^(?<fence>`{3,}|~{3,})[^\r\n]*\r?\n[\s\S]*?^\k<fence>[ \t]*(?:\r?\n|$)/gm ) ]
			return source.replace(
				/<([a-z][\w-]*)([^>]*)>([\s\S]*?)<\/\1(?:\s+instructions)?>/gi,
				( found, tag_raw: string, attributes: string, content: string, offset: number )=> {
					if( fences.some( fence => offset >= fence.index! && offset < fence.index! + fence[ 0 ].length ) ) return found
					const tag = tag_raw.toLowerCase()
					if( !this.internal_context_tag( tag, attributes ) ) return found

					const label = this.internal_context_title( tag, attributes )
					const body = content.replace( /^\r?\n/, '' ).replace( /\r?\n$/, '' )
					const spoiler = [ label, ... body.split( /\r?\n/ ) ].map( line => `? ${ line }` ).join( '\n' )
					const before = source.slice( 0, offset )
					const after = source.slice( offset + found.length )
					const lead = !before ? '' : /(?:\r?\n){2,}$/.test( before ) ? '' : /\r?\n$/.test( before ) ? '\n' : '\n\n'
					const tail = !after ? '' : /^(?:\r?\n){2,}/.test( after ) ? '' : /^\r?\n/.test( after ) ? '\n' : '\n\n'
					return `${ lead }${ spoiler }${ tail }`
				},
			)
		}

		@ $mol_mem
		override flow_tokens() {
			const source = this.internal_context_text()
			if( source === this.text() ) return super.flow_tokens()

			const tokens = [] as { name: string; found: string; chunks: string[] }[]
			this.$.$mol_syntax2_md_flow.tokenize(
				source,
				( name, found, chunks )=> tokens.push({ name, found, chunks }),
			)
			return tokens
		}

		override sub_visible() {
			return this.sub()
		}

		@ $mol_mem_key
		line_tokens( path: readonly number[] ) {
			const tokens = [] as { name: string; found: string; chunks: string[] }[]
			this.$.$mol_syntax2_md_line.tokenize(
				this.line_text( path ),
				( name, found, chunks )=> tokens.push({ name, found, chunks }),
			)
			if( this.embeds_allowed() ) return tokens
			return tokens.map( ( token: { name: string; found: string; chunks: string[] } )=> token.name === 'embed'
				? { ... token, name: '', chunks: [ token.found ] }
				: token,
			)
		}

		chart_block( index: number ) {
			const token = this.flow_tokens()[ index ]
			return token?.name === 'code' && token.chunks[ 1 ].trim().toLowerCase() === 'echarts'
		}

		@ $mol_mem_key
		chart_result( index: number ) {
			return $shm_agent_message_chart_parse( this.pre_text( index ) )
		}

		chart_option( index: number ) {
			return this.chart_result( index ).spec?.option ?? null
		}

		chart_height( index: number ) {
			return this.chart_result( index ).spec?.height ?? 320
		}

		chart_error( index: number ) {
			return `Не удалось построить график: ${ this.chart_result( index ).error }`
		}

		chart_invalid_rows( index: number ) {
			return [ this.Chart_error( index ), this.Pre( index ) ]
		}

		override rows() {
			const rows = [ ... super.rows() ]
			for( const [ index ] of this.flow_tokens().entries() ) {
				if( !this.chart_block( index ) ) continue
				rows[ index ] = this.chart_result( index ).spec
					? this.Chart( index )
					: this.Chart_invalid( index )
			}
			return rows
		}

	}

}
